import { storage, orcamentoCollection } from "../connections/FirebaseConnection";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { State } from "../FormContext";
import { Orcamento } from "../types/Orcamento";
import { doc, getDocs, setDoc, updateDoc } from "@firebase/firestore";


export const uploadRefs = async (file: File, celular: string) => {
    var url: string = '';
    if(['image/jpeg','image/jpg','image/png'].includes(file.type)){
        let rand = Math.floor(Math.random() * 100);
        let newFile = ref(storage, `Orcamentos/${celular}/${rand}`);
        let upload = await uploadBytes(newFile, file);
        url = await getDownloadURL(upload.ref);   
    }
    return url;
}

export const submitOrcamento = async (novo: State) => {
    const orcDoc = doc(orcamentoCollection);
    const dt = new Date();
    const mont = dt.getMonth() + 1;
    try {
        await setDoc(orcDoc, {
            birth: novo.birth,
            bodyPart: novo.bodyPart,
            celphone: novo.celphone,
            datePre: novo.datePre,
            description: novo.description,
            email: novo.email,
            estimatedSize: novo.estimatedSize,
            hourPre: novo.hourPre,
            instagram: novo.instagram,
            memberSide: novo.memberSide,
            name: novo.name,
            refs: novo.refs,    
            unMedida: novo.unMedida,
            status: false,
            sendDate: dt.getDate()+'/'+mont+'/'+dt.getFullYear()
        })
    }
    catch (e) {
        console.log('erro ao inserir:'+e);
    }

    return orcDoc;
}

export const getOrcamentos = async () => {
    let list : Orcamento [] = [];
    const orcDocs = await getDocs(orcamentoCollection);
    orcDocs.forEach((doc) => {
        list.push({
            id: doc.id,
            name: doc.data().name,
            birth: doc.data().birth,
            bodyPart: doc.data().bodyPart,
            celphone: doc.data().celphone,
            datePre: doc.data().datePre,
            description: doc.data().description,
            email: doc.data().email,
            estimatedSize: doc.data().estimatedSize,
            hourPre: doc.data().hourPre,
            instagram: doc.data().instagram,
            memberSide: doc.data().memberSide,
            refs: doc.data().refs,
            unMedida: doc.data().unMedida,
            status: doc.data().status,
            sendDate: doc.data().sendDate
        })
    })
    return list;
}